


























































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import LendingAccount from "@/models/Accounts/LendingAccounts/LendingAccount";
import { VuetifyConfirmObject } from 'vuetify-confirm';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import RepaymentPlanCreate from '@/components/Accounts/LendingAccounts/RepaymentPlans/RepaymentPlanCreate.vue';

@Component({ name: 'RepaymentPlans', components: { RepaymentPlanCreate } })
export default class extends SaascadaVue {

    @Prop({required: true})
    account: LendingAccount;

    headers = [
        { text: this.$t('pageText.lendingAccounts.fields.reference'), width: "50%", sortable: false },
        { text: this.$t('pageText.lendingAccounts.fields.totalRepaymentAmount'), width: "50%", sortable: false }
    ];
    repaymentPlansPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.repaymentPlansPage = +page;
        }
    }

    async beforeMount() {
        await LendingAccountModule.getRepaymentPlans(this.repaymentPlansPage);
    }

    async getRepaymentPlans() {
        await LendingAccountModule.getRepaymentPlans(this.repaymentPlansPage);
    }

    @Watch('repaymentPlansPage')
    async onRepaymentPlansPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.repaymentPlansPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.repaymentPlansPage}` } });
        }
        await LendingAccountModule.getRepaymentPlans(this.repaymentPlansPage);
    }

    async updateCurrentRepaymentPlan(repaymentPlan: {}) {
        await LendingAccountModule.updateCurrentRepaymentPlan(repaymentPlan);
    }

    get currentRepaymentPlan() {
        return LendingAccountModule.currentRepaymentPlan;
    }

    get loading() {
        return LendingAccountModule.loadingRepaymentPlans;
    }

    get totalRepaymentPlanPages() {
        return LendingAccountModule.totalRepaymentPlansPages;
    }

    get pageSize() {
        return LendingAccountModule.pageSize;
    }

    get repaymentPlans() {
        return LendingAccountModule.repaymentPlans;
    }

    async deleteRepaymentPlan() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this repayment plan?', options);
        if (result) {
            //await LendingAccountModule.deleteRepaymentPlan();
            await LendingAccountModule.getRepaymentPlans(1);
        }
    }

}
